import { network } from 'services/network';

import { QueryParams, QueryResponse } from 'api/queries/getProjectStatusScoreCards.query';

export const ENDPOINT = 'api/bo/getProjectStatusScoreCards';

export const getProjectStatusScoreCards = (params: QueryParams): Promise<QueryResponse> => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
